<template>
	<div class="hwk-login">
		<div class="login-main">
			<div class="logo"><img src="@/assets/logo.png" alt="" /></div>
			<div class="register">
				已有账号?<router-link to="login">立即登录</router-link>
			</div>

			<div class="middle">
				<ul class="m-nav">
					<li :class="{on:index==0}" @click="changeIndex(0)">账号</li>
					<li :class="{on:index==1}" @click="changeIndex(1)">手机号</li>
				</ul>
				<div class="m-main" v-if="index==0">
					<div class="from">
						<form>
							<div class="item">
								<img src="@/assets/login1.png" />
								<input type="text" v-model="username" placeholder="请输入账号">
							</div>
							<div class="item">
								<img src="@/assets/login2.png" />
								<input type="password" v-model="password" placeholder="请输入密码">
							</div>
							<div class="btn" @click="register(1)">
								完成注册
							</div>
						</form>
					</div>
				</div>
				<div class="m-main" v-if="index==1">
					<div class="from">
						<form>
							<div class="item">
								<img src="@/assets/login4.png" />
								<input type="number" v-model="mobile" placeholder="请输入手机号">
							</div>
							<div class="item">
								<img src="@/assets/login3.png" />
								<input type="text" v-model="code" placeholder="请输入验证码">
								<span @click="sendMsg" :class="{on:again_send}">{{codeText}}</span>
							</div>
							<div class="item">
								<img src="@/assets/login2.png" />
								<input type="password" v-model="password2" placeholder="8位以上密码,至少包含1个字母和数字">
							</div>
							<div class="item">
								<img src="@/assets/login2.png" />
								<input type="password" v-model="password3" placeholder="请再次输入密码">
							</div>
							<div class="btn" @click="register(2)">
								完成注册
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let timer = null
	export default {
		data() {
			return {
				username: "",
				password: "",
				list: [],
				pageSize: 0,
				page: 1,
				index: 0,
				isWeiXin: false,
				mobile: "",
				code: "",
				password2: '',
				password3: '',
				again_send: true,
				codeText: '获取验证码'
			};
		},
		created() {
			console.log('---------------------register---------------------', this.$route)
		},
		methods: {
			sendMsg() {
				function isValidPhoneNumber(phoneNumber) {
					// 正则表达式，匹配中国大陆手机号
					const phoneRegex = /^1[3-9]\d{9}$/;
					return phoneRegex.test(phoneNumber);
				}
				if (!this.mobile) {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return
				}
				if (this.mobile && !isValidPhoneNumber(this.mobile)) {
					this.$message({
						message: '手机号格式错误',
						type: 'warning'
					});
					return
				}
				if (!this.again_send) {
					this.$message({
						message: '请稍后再获取',
						type: 'warning'
					});
					return
				}
				this.again_send = false;
				this.$http.post('/api/index/sms_send', {
					mobile: this.mobile,
					event: "register"
				}).then(res => {
					if (res.code == 1) {
						let num = 60;
						timer = setInterval(() => {
							num--;
							this.codeText = num + 's后重发';
							if (num == 0) {
								clearInterval(timer);
								this.codeText = '重新发送';
								this.again_send = true
							}
						}, 1000)
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						});
					} else {
						this.again_send = true
					}
				});
			},
			register(i) {
				function isValidPhoneNumber(phoneNumber) {
					// 正则表达式，匹配中国大陆手机号
					const phoneRegex = /^1[3-9]\d{9}$/;
					return phoneRegex.test(phoneNumber);
				}
				if (i == 1) {
					if (!this.username) {
						this.$message({
							message: '用户名不能为空',
							type: 'warning'
						});
						return
					}
					if (!this.password) {
						this.$message({
							message: '密码不能为空',
							type: 'warning'
						});
						return
					}
					this.$http.post('/api/user/register_username', {
						username: this.username,
						password: this.password
					}).then(res => {
						if (res.code == 1) {
							this.$message({
								message: '恭喜你，注册成功',
								type: 'success'
							});
							// 假设token是你想要存储的值
							let token = res.data.userinfo.token;
							localStorage.setItem('token', token);
							let userId = res.data.userinfo.id
							localStorage.setItem('userId', userId);
							localStorage.setItem('userAttest', res.data.userinfo.is_attestation);
							let nickname = res.data.userinfo.nickname
							localStorage.setItem('nickname', nickname);
							localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
							this.$store.dispatch('setUserInfo', res.data.userinfo);
							let loginTime = new Date().getTime()
							localStorage.setItem('loginTime', loginTime);
							// 使用getItem方法获取token
							//let token = localStorage.getItem('token');
							// 当用户登出时，可以使用removeItem方法删除token
							//localStorage.removeItem('token');
							setTimeout(() => {
								this.$router.push({
									path: "/"
								});
							}, 2000)
						} else {
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
					});
				} else {
					if (!this.mobile) {
						this.$message({
							message: '手机号不能为空',
							type: 'warning'
						});
						return
					}
					if (this.mobile && !isValidPhoneNumber(this.mobile)) {
						this.$message({
							message: '手机号格式错误',
							type: 'warning'
						});
						return
					}
					if (!this.password2 || !this.password3) {
						this.$message({
							message: '密码不能为空',
							type: 'warning'
						});
						return
					}
					if (this.password2 !== this.password3) {
						this.$message({
							message: '2次密码不一致',
							type: 'warning'
						});
						return
					}
					this.$http.post('/api/user/register_phone', {
						mobile: this.mobile,
						password: this.password2,
						code: this.code
					}).then(res => {
						if (res.code == 1) {
							this.$message({
								message: '恭喜你，注册成功',
								type: 'success'
							});
							// 假设token是你想要存储的值
							let token = res.data.userinfo.token;
							localStorage.setItem('token', token);
							let userId = res.data.userinfo.id
							localStorage.setItem('userId', userId);
							localStorage.setItem('userAttest', res.data.userinfo.is_attestation);
							let nickname = res.data.userinfo.nickname
							localStorage.setItem('nickname', nickname);
							localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
							this.$store.dispatch('setUserInfo', res.data.userinfo);
							let loginTime = new Date().getTime()
							localStorage.setItem('loginTime', loginTime);
							// 使用getItem方法获取token
							//let token = localStorage.getItem('token');
							// 当用户登出时，可以使用removeItem方法删除token
							//localStorage.removeItem('token');
							setTimeout(() => {
								this.$router.push({
									path: "/"
								});
							}, 2000)

						} else {

							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
					});
				}
			},
			changeIndex(i) {
				this.index = i
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color: #FF6A00;

	.hwk-login {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: #333 url(../assets/bg2.png) center top no-repeat;
		background-size: cover;

		.login-main {
			position: absolute;
			right: 0;
			top: 0;
			bottom: 0;
			width: 620px;
			background-color: #fff;
			padding: 160px 110px 60px;
			box-sizing: border-box;

			.register {
				text-align: right;
				font-size: 20px;
				height: 30px;
				line-height: 30px;
				color: #3F3F3F;
				margin-top: 80px;

				a {
					color: #3572F5;
					text-decoration: none;
				}
			}

			.logo {
				width: 355px;
				height: 36px;
				margin: 0 auto;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.middle {
				width: 100%;
				margin: 30px auto;
				position: relative;

				.back {
					width: 20px;
					height: 20px;
					position: absolute;
					top: 10px;
					left: 0;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.btn {
					width: 100%;
					height: 50px;
					line-height: 50px;
					text-align: center;
					background-color: @color;
					font-size: 20px;
					color: #fff;
					border-radius: 4px;
					cursor: pointer;

					&:hover {
						background-color: #cf9236;
					}
				}


				.m-nav {
					display: flex;
					align-items: center;
					justify-content: center;
					text-align: center;
					border-bottom: 1px solid #eee;
					height: 40px;
					line-height: 40px;

					li {
						flex: 1;
						color: #A9A9A9;
						font-size: 20px;
						cursor: pointer;
					}

					.on {
						color: @color;
						font-weight: 600;
						position: relative;

						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 50%;
							width: 50px;
							height: 3px;
							border-radius: 1px;
							background-color: @color;
							margin-left: -24px;
						}
					}
				}


				.m-main {
					margin-top: 40px;

					.item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 50px;
						line-height: 50px;
						margin-bottom: 20px;
						border: 1px solid #F5F5F5;
						padding: 5px 10px;
						border-radius: 2px;

						img {
							width: 24px;
							height: 24px;
						}

						input {
							flex: 1;
							width: 1rpx;
							border: none;
							height: 50px;
							line-height: 50px;
							background-color: #fff;
							margin-left: 10px;
						}

						span {
							font-size: 14px;
							color: #999;
							cursor: pointer;
						}

						.on {
							color: @color;
						}

						.yzm {
							width: 150px;
							height: 50px;
							border: 1px solid #F5F5F5;

							img {
								width: 100%;
								height: 100%;
							}
						}
					}
				}
			}
		}
	}
</style>